import React, { useRef } from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp';
import FadeInSectionLeftToRight from '../../Components/FadeAnimations/FadeInSectionLeftToRight';
import FadeInSectionRightToLeft from '../../Components/FadeAnimations/FadeInSectionRightToLeft';
import { motion, useInView } from "framer-motion";
import VerticalMarquee from '../../Components/Vertical Marquee/VerticalMarquee';
import { FaFlag, FaLeaf } from "react-icons/fa6";
import { BiSolidDish } from "react-icons/bi";
import { FaHeart, FaMedal } from "react-icons/fa";
import { PiBuildingsFill } from "react-icons/pi";

export default function Restaurant() {

    const splitText = "At Restoran AL-BIDAYAH, we’re not just serving food we’re serving a legacy. With over 30 years of culinary excellence, our journey has been rooted in passion, tradition, and a deep love for flavor. From timeless family recipes to signature creations, we offer a menu filled with diverse and delicious dishes that have been cherished by generations. Whether you're here for a comforting classic or something bold and new, every plate is prepared with care, authenticity, and heart. Come experience the taste of tradition that continues to inspire smiles one dish at a time.";
    const words = splitText.split(" ");

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    const imageUrls = [
        "https://albidayahgroups.com/Media/Restaurant/DSC07114.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07497.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07507.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07557.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07571.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07578.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07592.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07644.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07822.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07837.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07917.JPG",
        "https://albidayahgroups.com/Media/Restaurant/DSC07942.JPG",
    ];

    const points = [
        {
            text: <>30+ Years of<br className='max-sm:hidden' /> Culinary Legacy</>,
            icon: <FaFlag className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
        {
            text: <>Fresh Ingredients,<br className='max-sm:hidden' /> Always</>,
            icon: <FaLeaf className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
        {
            text: <>250+ Signature<br className='max-sm:hidden' /> Dishes</>,
            icon: <BiSolidDish className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
        {
            text: <>Award-Winning<br className='max-sm:hidden' /> Taste</>,
            icon: <FaMedal className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
        {
            text: <>20000+ Happy<br className='max-sm:hidden' /> Customers Served Everyday</>,
            icon: <FaHeart className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
        {
            text: <>Warm & Welcoming<br className='max-sm:hidden' /> Atmosphere</>,
            icon: <PiBuildingsFill className="text-yellow-400 text-3xl shrink-0 mt-1" />,
        },
    ];

    return (
        <div>
            <div className="relative w-full h-screen">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/DSC07644.JPG')` }}
                ></div>

                {/* Milled Dark Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div>

                {/* Text Overlay - Left Side */}
                <div className="relative z-10 flex items-center h-full px-6 md:px-16">
                    <div className="text-white">
                        <FadeInSectionDownToUp>
                            <h1 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                A Taste of Nature,<br />Served <span className='text-yellow-500'>Fresh.</span>
                            </h1>
                            <p className="text-lg md:text-xl max-w-xl">
                                Welcome to <strong>Restoran AL-BIDAYAH</strong> where every bite is a journey to purity and flavor.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
            <div className="relative w-full h-full py-20 max-sm:py-10">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-10"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
                />

                {/* Milled Dark Overlay */}
                {/* <div className="absolute inset-0 bg-black bg-opacity-50 mix-blend-multiply"></div> */}

                {/* Text Overlay - Left Side */}
                <div className="relative z-10 flex max-sm:flex-col items-center gap-20 max-sm:gap-10 h-full px-5 md:px-16">
                    <div className="text-black w-full">
                        <FadeInSectionLeftToRight>
                            <p className="text-4xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                About<br /> <span className='text-yellow-500 text-6xl max-sm:text-4xl'>Restoran AL-BIDAYAH</span>
                            </p>
                            <p className="text-lg md:text-xl text-justify">
                                At Restoran AL-BIDAYAH , we’re not just serving food we’re serving a legacy.
                                With over 30 years of culinary excellence, our journey has been rooted in
                                passion, tradition, and a deep love for flavor. From timeless family recipes to
                                signature creations, we offer a menu filled with diverse and delicious dishes
                                that have been cherished by generations. Whether you're here for a
                                comforting classic or something bold and new, every plate is prepared with
                                care, authenticity, and heart. Come experience the taste of tradition that
                                continues to inspire smiles one dish at a time.
                            </p>
                        </FadeInSectionLeftToRight>
                    </div>
                    {/* <div ref={ref} className="text-black w-full py-20">
                        <FadeInSectionLeftToRight>
                            <p className="text-4xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                About<br />
                                <span className="text-yellow-500 text-6xl">Restoran AL-BIDAYAH</span>
                            </p>
                            <div className="flex flex-wrap gap-2">
                                {words.map((word, wordIndex) => (
                                    <div key={wordIndex} className="flex">
                                        {word.split("").map((letter, letterIndex) => (
                                            <motion.span
                                                key={letterIndex}
                                                initial={{ filter: "blur(10px)", opacity: 0, y: 12 }}
                                                animate={
                                                    isInView
                                                        ? { filter: "blur(0px)", opacity: 1, y: 0 }
                                                        : { filter: "blur(10px)", opacity: 0, y: 12 }
                                                }
                                                transition={{
                                                    duration: 0.4,
                                                    delay: 0.02 * (wordIndex * 5 + letterIndex),
                                                }}
                                                className="text-xl max-sm:text-base"
                                            >
                                                {letter}
                                            </motion.span>
                                        ))}
                                        <span className="text-xl max-sm:text-base">&nbsp;</span>
                                    </div>
                                ))}
                            </div>
                        </FadeInSectionLeftToRight>
                    </div> */}
                    <div className="w-full">
                        <FadeInSectionRightToLeft>
                            <img className='rounded-2xl' src='https://albidayahgroups.com/Media/Restaurant/DSC03437.JPG' alt='AL-BIDAYAH' />
                        </FadeInSectionRightToLeft>
                    </div>
                    {/* <div className="py-10 px-4">
                        <div className="flex flex-wrap gap-2 px-40 max-sm:px-5">
                            {words.map((word, wordIndex) => (
                                <div key={wordIndex} className="flex">
                                    {word.split("").map((letter, letterIndex) => (
                                        <motion.span
                                            key={letterIndex}
                                            initial={{ filter: "blur(10px)", opacity: 0, y: 12 }}
                                            animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
                                            transition={{ duration: 0.5, delay: 0.02 * (wordIndex * 5 + letterIndex) }}
                                            className="text-xl max-sm:text-base"
                                        >
                                            {letter}
                                        </motion.span>
                                    ))}
                                    <span className="text-xl max-sm:text-base">&nbsp;</span>
                                </div>
                            ))}
                        </div>
                    </div> */}
                </div>
                <div className='relative z-10 px-20 max-sm:px-5 pt-20 max-sm:pt-5 space-y-5'>
                    <div>
                        <FadeInSectionDownToUp>
                            <p className='text-3xl font-bold'>Why Choose Us?</p>
                        </FadeInSectionDownToUp>
                    </div>
                    <div className="relative w-full h-full rounded-3xl overflow-hidden">
                        {/* Background Image */}
                        <div
                            className="absolute inset-0 bg-cover bg-center opacity-50 rounded-3xl"
                            style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/WhyChoose')` }}
                        ></div>

                        {/* Milled Dark Overlay */}
                        <div className="absolute inset-0 bg-orange-950 mix-blend-multiply rounded-3xl"></div>

                        <div className='flex max-sm:flex-col justify-between items-center relative'>
                            <FadeInSectionDownToUp>
                                <div className="grid grid-cols-2 xl:grid-cols-2 sm:grid-cols-3 max-sm:grid-cols-1 gap-16 max-sm:gap-10 px-10 py-10 max-sm:py-10 z-50">
                                    {points.map((point, index) => (
                                        <div key={index} className="flex items-center gap-3">
                                            <span className='bg-white rounded-full p-2'>{point.icon}</span>
                                            <span className="text-3xl xl:text-3xl sm:text-2xl max-sm:text-xl font-medium text-white">{point.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </FadeInSectionDownToUp>
                            <div className='xl:overflow-visible sm:overflow-hidden max-sm:overflow-hidden xl:block sm:hidden max-sm:block'>
                                <div className="flex gap-5 h-full py-10 -rotate-[30deg]">
                                    <VerticalMarquee direction="down" speed={12} height="h-80">
                                        {imageUrls.map((url, index) => (
                                            <img
                                                key={index}
                                                className="rounded-lg w-20"
                                                src={url}
                                                alt={`AL-BIDAYAH ${index}`}
                                            />
                                        ))}
                                    </VerticalMarquee>
                                    <VerticalMarquee direction="up" speed={12} height="h-80">
                                        {imageUrls.map((url, index) => (
                                            <img
                                                key={index}
                                                className="rounded-lg w-20"
                                                src={url}
                                                alt={`AL-BIDAYAH ${index}`}
                                            />
                                        ))}
                                    </VerticalMarquee>
                                    <VerticalMarquee direction="down" speed={12} height="h-80">
                                        {imageUrls.map((url, index) => (
                                            <img
                                                key={index}
                                                className="rounded-lg w-20"
                                                src={url}
                                                alt={`AL-BIDAYAH ${index}`}
                                            />
                                        ))}
                                    </VerticalMarquee>
                                    <VerticalMarquee direction="up" speed={12} height="h-80">
                                        {imageUrls.map((url, index) => (
                                            <img
                                                key={index}
                                                className="rounded-lg w-20"
                                                src={url}
                                                alt={`AL-BIDAYAH ${index}`}
                                            />
                                        ))}
                                    </VerticalMarquee>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='relative w-full h-full px-20 max-sm:px-5 py-20 max-sm:py-10'>
                    <div className="text-black w-full">
                        <FadeInSectionDownToUp>
                            <p className="text-4xl text-orange-950 max-sm:text-4xl font-bold mb-4 leading-tight">
                                Signature Dishes !
                            </p>
                            <p className="text-3xl max-sm:text-2xl text-justify">
                                Our menu is a blend of bold flavors, seasonal produce, and artisanal techniques - brought
                                together in perfect harmony.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                    <img className='w-full' src='https://albidayahgroups.com/Media/Restaurant/Group%2012.png' alt='AL-BIDAYAH' />
                </div>
            </div>
        </div>
    )
}
